export default __webpack_public_path__ + "static/media/ic_back.0fcd0ac6.svg";